<template>

    <div class="c-editor">
        <div v-if="multiLingual===true">

            <b-form-group
                    class="c-text"
                    :description="description"
                    :label="label"
                    :label-for="id"
                    :label-cols="labelCols"
                    :aria-describedby="id + '_InvalidFeedback'">

                <b-tabs fill>
                    <b-tab :key="languageIndex" v-for="language, languageIndex in Core.Local.languages">
                        <template slot="title">
                            {{language.label}}
                        </template>
                        <quill-editor
                                @change="change(id + '_' + language.value, language.value)"
                                :ref="id + '_' + language.value"
                                :id="id + '_' + language.value"
                                :scrollingContainer="false"
                                :content="dataValue[language.value]"
                                :options="dataOptions"
                                :v-model="dataValue[language.value]"/>
                    </b-tab>
                </b-tabs>

                <b-form-invalid-feedback :id="id + '_InvalidFeedback'">
                    {{invalidFeedbackMessage}}
                </b-form-invalid-feedback>
            </b-form-group>
        </div>

        <div v-if="multiLingual===false">
            <b-form-group
                    class="c-text"
                    :description="description"
                    :label="label"
                    :label-for="id"
                    :label-cols="labelCols"
                    :aria-describedby="id + '_InvalidFeedback'">
                <quill-editor
                        ref="quillEditor"
                        v-model="dataValue"
                        :options="dataOptions"/>

                <b-form-invalid-feedback :id="id + '_InvalidFeedback'">
                    {{invalidFeedbackMessage}}
                </b-form-invalid-feedback>
            </b-form-group>
        </div>

    </div>

</template>

<script>
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'

    import { quillEditor } from 'vue-quill-editor'

  export default {
      name: 'InputEditor',
      components: {
          quillEditor
      },
      props: {
          required: {
              type: Boolean,
              default: false
          },
          value: {
              type: String,
              default: ''
          },
          id: {
              type: String,
              default: ''
          },
          label: {
              type: String,
              default: ''
          },
          placeholder: {
              type: String,
              default: ''
          },
          description: {
              type: String,
              default: ''
          },
          labelCols: {
              type: Number,
              default: 0
          },
          autocomplete: {
              type: String,
              default: ''
          },
          readOnly: {
              type: Boolean,
              default: false
          },
          invalidFeedbackMessage: {
              type: String,
              default: ''
          },
          form: {
              type: Object,
              default: function() {return {}}
          },
          multiLingual: {
              type: Boolean,
              default: false
          }
      },
      watch: {
          value(val) {
              if (this.multiLingual===true) {
                  val = Core.Local.prepareValue(val)
              }
              this.dataValue = val
          },
          dataValue(val) {
              if (this.multiLingual===true) {
                  val = Core.Local.prepareValue(val)
              }
              this.$emit('input', val)
          }
      },
      mounted() {
          if(this.multiLingual===true) {
              this.dataValue = Core.Local.prepareValue(value)
          } else {
              this.dataValue = this.value
          }
      },
      data: () => {
          return {
              Core: window.Core,
              dataValue: '',
              dataOptions: {
                  placeholder: '',
                  readOnly: false,
                  theme: 'snow'
              }
          }
      },
      methods: {
          chkState(val) {
              if (this.form !== undefined && this.form[val] !== undefined) {
                  const field = this.form[val]
                  return !field.$dirty || !field.$invalid
              }
          },
          change(ref, lang) {
              if (lang !== undefined) {
                  if (this.$refs[ref]!==undefined&&this.$refs[ref][0]!== undefined&&this.$refs[ref][0]._content!==undefined) {
                      let value = this.$refs[ref][0]._content
                      this.dataValue[lang] = value
                  }
              } else {
                  this.dataValue = ref
              }
          }
      }
  }
</script>